import Button from "@src/components/UIElements/Button";
import Link from "@src/lib/Link";
import React from "react";
import styles from "../../../styles/FreeContentOverview.module.scss";
import ContentList from "../../ContentList";
import { useSelector } from "react-redux";
import { useRouter } from "@src/lib/router";
import { COURSE_TABS_ENUMS } from "@src/utils/constants";
import RightArrowIcon from "@src/components/AccentIcons/RightArrowIcon";
import { t } from "i18next";
import { newWebEngage } from "@src/utils/webEngageEvent";

const FreeContentOverview = () => {
  // FETCHING DATA FROM REDUCER
  const freeContent = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.freeContent
  );
  const freeContentLen = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.freeContentCount
  );

  const contentTabId = useSelector(
    (state) =>
      state?.tabBarReducer?.tabList?.find?.(
        (tab) => tab?.enumKey === COURSE_TABS_ENUMS.CONTENT
      )?.id
  );

  // NEXTJS ROUTER
  const router = useRouter();

  // RETURNING NULL IF NO FREE CONTENT
  if (!freeContent?.length) return null;

  // REDIRECT TO ALL FREE CONTENT PAGE
  const redirectToFreeContent = () => {
    newWebEngage("course_free_content_view", {
      action: "View All Free Content Click",
    });
    router.push(`/${router?.query?.courseId}/freecontent`);
  };

  const redirectToContent = () => {
    newWebEngage("course_full_syllabus_view", {
      action: "View Full Syllabus Click"
    });
    router.push(`/${router?.query?.courseId}/${contentTabId}`);
  }

  return (
    <div className={styles.freeContentOverview}>
      <div className={styles.freeContentOverview__header}>
        <div className={styles.freeContentOverview__header__heading}>
          {t(
            "components.tabs.content.components.freeContent.freeContentOverview.index.freeContentHeading",
            "Free Content"
          )}
        </div>
        <div className={styles.freeContentOverview__header__highlightedText} onClick={redirectToContent}>
          {t(
            "components.tabs.content.components.freeContent.freeContentOverview.index.viewFullSyllabusText",
            "View Full Syllabus"
          )}
          <RightArrowIcon />
        </div>
      </div>
      <ContentList contentList={freeContent} />
      {freeContentLen > 3 ? <div className={styles.freeContentOverview__footer}>
        <Button
          onClick={redirectToFreeContent}
          outline
          bRadius4
          style={{ padding: "8px" }}
        >
          {t(
            "components.tabs.content.components.freeContent.freeContentOverview.index.viewAllFreeContentButtonText",
            "View All Free Content"
          )}
        </Button>
      </div> : null}
    </div>
  );
};

const MemoizedFreeContentOverview = React.memo(FreeContentOverview);

export default MemoizedFreeContentOverview;
